import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import styles from './ChatScrollLayout.css';

type TProps = {
  isLoading: boolean;
  pagesNode: React.ReactNode;
  removalDateNode: React.ReactNode;
  archiveInfoNode: React.ReactNode;
};

export const ChatScrollLayout: React.FC<TProps> = ({ isLoading, pagesNode, removalDateNode, archiveInfoNode }) => {
  return (
    <>
      <div className={styles['pages']}>
        {isLoading && (
          <div className={styles['preloader']}>
            <Spinner size={16} />
          </div>
        )}
        {pagesNode}
      </div>
      {removalDateNode}
      {archiveInfoNode}
    </>
  );
};
